import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import styles from './BarChartCard.module.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const BarChartCard = ({ title, data, useAccumulatedSumInToolTip }) => {

    const options = {
        responsive: true,
        maintainAspectRatio: false, // Ensure the chart takes the full width of its container
        resizeDelay: 200,
        interaction: {
            intersect: false,
            mode: 'nearest',
            axis: 'x'
        },
        plugins: {   
            legend: {
                position: 'top',
                align: 'start',
                labels: {
                    font: {
                        family: 'Space Grotesk', // Set the font family for the legend
                    }
                },
                onClick: null
            },
            title: {
                display: false,
            },
            tooltip: {
                enabled: true,
                backgroundColor: '#ffff',
                borderColor: '#aaa',
                borderWidth: 1,
                titleColor: '#000',
                bodyColor: '#000',
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label ? `  ${context.dataset.label}` : ' ';
                        if (label) {
                            label += ': ';
                        }

                        let accumulatedValue = 0;
                        context.chart.data.datasets.forEach((dataset, i) => {
                            if (i <= context.datasetIndex && dataset.data[context.dataIndex] !== undefined) {
                                accumulatedValue += dataset.data[context.dataIndex];
                            }
                        });
                        label += useAccumulatedSumInToolTip ? accumulatedValue : context.chart.data.datasets[context.datasetIndex].data[context.dataIndex];
                        return label;
                    }
                }
            },
            datalabels: {
                color: 'black',
                font: {
                    weight: 'bold',
                    family: 'Space Grotesk', // Set the font family for the x-axis                
                },
                anchor: "end",
                align: "start",
                offset: -20,
                formatter: (value, context) => {
                    let accumulatedValue = 0;
                    context.chart.data.datasets.forEach((dataset, i) => {
                        accumulatedValue += dataset.data[context.dataIndex];
                    });
                    return context.datasetIndex === context.chart.data.datasets.length - 1 ? accumulatedValue.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                ticks: {
                    font: {
                        family: 'Space Grotesk', // Set the font family for the x-axis
                    },
                },
            },
            y: {
                stacked: true,
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
        },
    };

    const plugin = {
        beforeInit: function (chart) {
          // Get reference to the original fit function
          const originalFit = chart.legend.fit
      
          // Override the fit function
          chart.legend.fit = function fit() {
            // Bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)()
            this.height += 20 // Change the height
          }
        }
      }

    return (
        <div className={styles.card}>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.chartContainer}>
                {data
                    ? <Bar plugins={[plugin]} options={options} data={{
                        ...data,
                        datasets: data.datasets.map(i => { return { ...i, borderWidth: 0, borderRadius: 6, } })
                    }} />
                    : <span>{data === undefined ? 'Loading' : "Error getting data"}</span>
                }
            </div>
        </div>
    );
};

export default BarChartCard;